import React from 'react';
import { Box, LayoutProps } from '@chakra-ui/react';

interface BackgroundImageProps {
  imageUrl: string;
  children: React.ReactNode;
  height?: LayoutProps['height'];
  minHeight?: LayoutProps['minHeight'];
}

const BackgroundImage = ({
  imageUrl,
  height = 'fit-content',
  minHeight = '',
  children,
}: BackgroundImageProps) => (
  <Box
    w="100%"
    height={height}
    minHeight={minHeight}
    bgImage={`url(${imageUrl})`}
    bgPos="bottom"
    bgRepeat="no-repeat"
    bgSize="cover"
  >
    {children}
  </Box>
);

BackgroundImage.defaultProps = { height: 'fit-content', minHeight: '' };

export default BackgroundImage;
